import { CHART_COLORS, baseColumnConfig } from './chartStyle';

/**
 * Configuration function for monthly supervisions chart.
 * @param {Object} params - The parameters for the monthlySupervisionsChartConfig function.
 * @param {Array} params.monthlySupervisionsChartData - Data for the monthly supervisions chart.
 * @param {Function} params.t - Translation function for internationalization.
 * @returns {Object} - Configuration object for the monthly supervisions chart.
 */
export const monthlySupervisionsChartConfig = ({
  monthlySupervisionsChartData,
  t
}) => ({
  ...baseColumnConfig(),
  data: monthlySupervisionsChartData,
  xField: 'month',
  yField: 'number',
  legend: false,
  style: {
    fill: CHART_COLORS.cambridge,
    radiusTopLeft: 4,
    radiusTopRight: 4,
    maxWidth: 28
  },
  tooltip: {
    items: [
      (item) => ({
        name: t('dashboard.tabs.supervisions.number'),
        value: item.number
      })
    ]
  }
});
